import React from "react";
import LinkButton from "./LinkButton";
import "../style/action.scss";

export default function ActionSection() {
  return (
    <>
      <div className="container action_section">
        <div className="wrapper">
          <h2>Spremni za savršene obrve?</h2>
          <p>
            Postignite prirodan i postojan izgled uz puder obrve koje
            naglašavaju vašu lepotu. Kontaktirajte me i zakoračite u svet
            definisanih i negovanih obrva!
          </p>
          <LinkButton link="/kontakt" buttonText="Besplatna konsultacija" />
        </div>
      </div>
    </>
  );
}
